import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { navigate } from 'gatsby'
import Text from 'components/Text'
import Button from 'components/Button'
import router from 'utils/router'
import analytics from '@mobi/libraries/analytics'
import './LandingPartners.scss'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import PartnersLogos from './components/PartnersLogos'

const LandingPartners = () => {
  return (
    <div className="landing-partners">
      <Text h2 className="partners-top-part">
        Aqui você pode renegociar dívidas de:
      </Text>
      <div
        className="partners-middle-part"
        data-test="partners-logos-container"
      >
        <PartnersLogos />
      </div>
      <div className="partners-bottom-part">
        <Button
          className="button"
          onClick={() => {
            analytics.track('segmentButtonClick', {
              name: 'ConsultarCpf:Parceiros',
              id: '3de050cd-cb37-412b-9a30-f865f3760327',
            })
            handlePerformanceMark(ROUTES.register.pageName)
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          data-unique="3de050cd-cb37-412b-9a30-f865f3760327"
          data-test="partners-consult-button"
          data-tracking-location="lp"
          data-tracking-position="lp-cta"
          data-tracking-actionoutcome="check_cpf"
          data-tracking-element="button"
          data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
        >
          consultar
        </Button>
      </div>
    </div>
  )
}

export default LandingPartners
